import React from 'react';
import moment from 'moment';
import { styledDefaultColDef } from '../../../../extras/cellRenderers';

const cell = (render) => ({
  cellRenderer: (params) => (
    <div className="flex items-center h-full">{render(params)}</div>
  ),
});

export const columnDefs = [
  {
    headerName: 'Name',
    field: 'studentName',
    filter: 'agTextColumnFilter',
    filterParams: { suppressAndOrCondition: true, filterOptions: ['contains'] },
    width: 200,
    ...cell((p) => p?.data?.studentName || '-'),
  },
  {
    headerName: 'Mobile No',
    field: 'studentPhone',
    width: 150,
    filter: 'agTextColumnFilter',
    filterParams: { suppressAndOrCondition: true, filterOptions: ['equals'] },
    ...cell((p) => p?.data?.studentPhone || '-'),
  },
  {
    headerName: 'Email',
    field: 'studentEmail',
    width: 250,
    filter: 'agTextColumnFilter',
    filterParams: { suppressAndOrCondition: true, filterOptions: ['equals'] },
    ...cell((p) => p?.data?.studentEmail || '-'),
  },
  {
    headerName: 'Created At',
    field: 'created_at',
    width: 150,
    filter: 'agDateColumnFilter',
    filterParams: {
      suppressAndOrCondition: true,
      filterOptions: ['equals', 'greaterThan', 'lessThan'],
      valueGetter: (props) => props.data?.created_at ? moment(props.data.created_at).format('YYYY-MM-DD') : null,
    },
    ...cell((p) =>
      p?.data?.created_at ? moment(p.data.created_at).format('DD MMM YYYY, HH:mm') : '-'
    ),
  },
  {
    headerName: 'Enrolment Date & Time',
    field: 'date',
    width: 200,
    filter: 'agDateColumnFilter',
    filterParams: {
      suppressAndOrCondition: true,
      filterOptions: ['equals', 'greaterThan', 'lessThan'],
      valueGetter: (props) => props.data?.date ? moment(props.data.date).format('YYYY-MM-DD') : null,
    },
    ...cell((p) =>
      p?.data?.date ? moment(p.data.date).format('DD MMM YYYY') : '-'
    ),
  },
  {
    headerName: 'Program',
    field: 'course',
    width: 200,
    filter: 'agTextColumnFilter',
    filterParams: { suppressAndOrCondition: true, filterOptions: ['contains'] },
    ...cell((p) => p?.data?.course || '-'),
  },
  {
    headerName: 'Enrollment Status',
    field: 'enrollmentStatus',
    width: 180,
    filter: 'agTextColumnFilter',
    filterParams: { suppressAndOrCondition: true, filterOptions: ['equals'] },
    cellRenderer: (params) => {
      const status = params?.data?.enrollmentStatus;
      if (!status) return <div className="flex items-center h-full">-</div>;
      const styleMap = {
        Completed:  { bg: '#D1FAE5', color: '#065F46' },
        Active:     { bg: '#D1FAE5', color: '#065F46' },
        Pending:    { bg: '#FEF3C7', color: '#92400E' },
        Cancelled:  { bg: '#FEE2E2', color: '#991B1B' },
        Failed:     { bg: '#FEE2E2', color: '#991B1B' },
        Rejected:   { bg: '#FEE2E2', color: '#991B1B' },
      };
      const s = styleMap[status] || { bg: '#F3F4F6', color: '#4B5563' };
      return (
        <div className="flex items-center h-full">
          <span style={{
            display: 'inline-flex', alignItems: 'center',
            backgroundColor: s.bg, color: s.color,
            borderRadius: 9999, padding: '2px 10px',
            fontSize: 11.5, fontWeight: 600, whiteSpace: 'nowrap',
          }}>
            {status}
          </span>
        </div>
      );
    },
  },
  {
    headerName: 'Message Script',
    field: 'messageByScript',
    width: 220,
    filter: 'agTextColumnFilter',
    filterParams: { suppressAndOrCondition: true, filterOptions: ['contains'] },
    ...cell((p) => p?.data?.messageByScript || '-'),
  },
  {
    headerName: 'Notes',
    field: 'notes',
    width: 220,
    filter: 'agTextColumnFilter',
    filterParams: { suppressAndOrCondition: true, filterOptions: ['contains'] },
    ...cell((p) => p?.data?.notes || '-'),
  },
  {
    headerName: 'Action',
    pinned: 'right',
    sortable: false,
    suppressMenu: true,
    width: 130,
    cellRenderer: 'actionCellRenderer',
  },
];

export const defaultColDef = {
  ...styledDefaultColDef,
  filter: false,
  sortable: false,
};
